import Nullstack from 'nullstack';
export default function IconBookOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-book-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 19a9 9 0 0 1 9 0a8.999 8.999 0 0 1 5.899 -1.096"
  }), "   ", Nullstack.element("path", {
    d: "M3 6a8.995 8.995 0 0 1 2.114 -.884m3.8 -.21c1.07 .17 2.116 .534 3.086 1.094a9 9 0 0 1 9 0"
  }), "   ", Nullstack.element("path", {
    d: "M3 6v13"
  }), "   ", Nullstack.element("path", {
    d: "M12 6v2m0 4v7"
  }), "   ", Nullstack.element("path", {
    d: "M21 6v11"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}